import * as React from "react";
const SvgVerticalLine = (props) => /* @__PURE__ */ React.createElement("svg", { width: 23, height: 188, viewBox: "0 0 23 188", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.5 1L21.5 94L0.5 187", stroke: "#DFDFDF" }));
export default SvgVerticalLine;
